module.exports = __webpack_public_path__ + "img/c74.60bd2d5f.png";